import validate from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}